import MComponent from '../../Toolkit/Components/Component';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import WithRouterProps from '../../Toolkit/WithRouterProps';
import WithRouter from '../../Toolkit/WithRouter';
import React, {ReactElement} from 'react';
import {MPageProps} from '../../Toolkit/Components/Shell/Page';
import {DayView} from '../../Api/ControllerTypes/JobAssignmentTypes';
import EnumContext from '../../Context/enum-context';
import PowerBiList, {ReportData} from '../../Components/Toolkit/PowerBiList';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import {GroupReply, ReportMultiReply} from '../../Api/ControllerTypes/ReportTypes';
import NSwagAdapter from '../../Toolkit/Api/NSwagAdapter';
import {PowerBiClient} from '../../Api/PowerBiClient';
import MNSwagClientConfiguration from '../../Toolkit/Api/NSwagClientConfiguration';
import TrafficManagementAccessTokenProvider from '../../Api/TrafficManagementAccessTokenProvider';

type Props = WithMsalProps & WithRouterProps & {};

type State = {
    page: MPageProps;
    displayDate: Date;
    itemData: DayView[];
    selectedRow: DayView | undefined;
    reportConfig: models.IReportEmbedConfiguration;
    data: ReportData[];
};

class ReportsPage extends MComponent<Props, State>{
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private readonly m_powerBiClient: NSwagAdapter<PowerBiClient>;

    public constructor(props: Props){
        super(props);

        this.bindMethods();

        this.m_powerBiClient = new NSwagAdapter<PowerBiClient>(new PowerBiClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));

        this.initializeState();
    }

    private bindMethods(): void{
        this.loadReportList = this.loadReportList.bind(this);
        this.itemSelected = this.itemSelected.bind(this);
    }

    private initializeState(): void {
        const page: MPageProps = {
            locked: false
        };

        const todayDate = new Date();
        todayDate.setHours(12,0,0);

        const reportConfig: models.IReportEmbedConfiguration = {
            type: 'report',
            embedUrl: undefined,
            accessToken: undefined,
            id: undefined,
            tokenType: models.TokenType.Embed,
            settings: {
                panes: {
                    filters: {
                        expanded: false,
                        visible: true
                    }
                },
                background: models.BackgroundType.Transparent,
            }
        }

        this.state = {
            page: page,
            displayDate: todayDate,
            selectedRow: undefined,
            itemData: [],
            data: [],
            reportConfig: reportConfig
        }
    }

    public componentDidMount(): void {
        this.loadReportList();
    }

    private async loadReportList(): Promise<void> {

        const group = await this.m_powerBiClient.callWithReply(GroupReply,
                client => client.getGroup('TrafficManApp'));
        group.throwIfFailed();

        const reports = await this.m_powerBiClient.callWithReply(ReportMultiReply,
                client => client.listReports(group.reply!.group!.groupId));
        reports.throwIfFailed();

        this.safeSetState(draft => {
                draft.data = reports.reply!.reports;
                draft.reportConfig.accessToken = reports.reply!.embedToken;
        });
    }

    private itemSelected(selectedItem: ReportData) {
        this.safeSetState(draft => {
            draft.reportConfig.accessToken = this.state.reportConfig.accessToken;
            draft.reportConfig.id = selectedItem.reportId!;
            draft.reportConfig.embedUrl = selectedItem.embedUrl!;
        });
    }

    public render(): ReactElement {

        return (
            <div className="formgrid grid">
                <div className="col-12">
                    <div className="col-12 md:col-2" style={{display: 'inline-grid', verticalAlign: 'top', height: 'calc(100vh - 150px)'}}>
                        <PowerBiList msalContext={this.props.msalContext}
                                     data={this.state.data}
                                     className={'p-inputgroup'}
                                     itemSelected={d => this.itemSelected(d)}
                        />
                    </div>

                    <div className="col-12 md:col-10" style={{display: 'inline-grid', height: 'calc(100vh - 150px)'}}>
                        <PowerBIEmbed embedConfig = {this.state.reportConfig}
                                      cssClassName={'power-bi-report-class p-inputgroup'}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withMsal(WithRouter(ReportsPage));